import React, { useContext, useEffect, useState, useMemo } from 'react';

import { getAllAreasByDiretoriaOptions } from '@app/api/area';
import { getAllMunicipiosOptions } from '@app/api/municipio';
import {
  AbaInformacaoComplementar,
  getInformacaoComplementarById,
  updateDadosReajusteContrato,
  updateFrequenciaMedicaoContrato,
  updateOutrasInformacoesContrato,
  updateCronologiaMedicaoContrato,
  updateResponsaveisFornecedorContrato,
  updateResponsaveisMrnContrato,
} from '@app/api/contrato/informacaoComplementar';
import { getAllDepartamentoProAreaIdOptions, getAllDepartamentoProDiretoriaIdOptions } from '@app/api/departamento';
import { getAllDiretoriasOptions } from '@app/api/diretoria';
import {
  getAllFrequenciasOptions,
  getAllFrequenciasSlaOptions,
  getAllTiposMedicaoOptions,
} from '@app/api/frequenciaMedicao';
import {
  getAllFiscaisOptions,
  getAllGestoresOptions,
  getAllTenicoMedicaoOptions,
  getAllAdministradoresContratoOptions,
  getAllUsuarioResponsavelRateioOptions,
} from '@app/api/usuario';
import { hasPermission } from '@app/helpers/permissions';
import {
  CrudContext,
  FormatText,
  FormInput,
  FormSelect,
  FormSubmitButton,
  FormSwitch,
  FormTextArea,
  MasterDetailForm,
  OptionProps,
  usePromise,
  Widget,
  FormDatePicker,
  FormContext,
  FormNumber,
  Col,
  FormCheckbox,
} from '@digital/ui';
import { Collapse, Icon } from 'antd';
import { Divider, Modal } from 'antd';
import * as Yup from 'yup';
import { updateDadosClassificacaoServicoContrato } from '@app/api/contrato/geral';
import { getClassificacaoServicoForOptions } from '@app/api/classificacaoServico';
import { Visibility } from '@app/components/Visibility';
import { PanelResponsaveisMrnV2 } from './panelResponsaveisMrnV2';
import { EGuidTipoSasFrequenciaMedicao } from '@app/enums/EGuidTipoSasFrequenciaMedicao';
import { PanelResponsaveisFornecedorV2 } from './panelResponsaveisFornecedorV2';

const { Panel } = Collapse;

const onSearch = (val: any) => {
  return true;
};

interface ContratoFormProps {
  onUpdate: () => any;
  isMultiplosGestores?: boolean;
  isConsolidado?: boolean;
}

const AbaInfoComplementar = ({
  onUpdate,
  isMultiplosGestores,
  isConsolidado
}: ContratoFormProps) => {

  const [idDiretoria, setIdDiretoria] = useState<string | undefined>('');
  const [idAreaId, setIdAreaId] = useState<string | undefined>('');
  const [TipoMedicao, setTipoMedicao] = useState();
  const [PossuiSLA, setPossuiSLA] = useState();
  const [frequencia, setFrequencia] = useState();
  const { selectedItem } = useContext(CrudContext);
  const [valoFrequenciaSla, setValorFrequenciaSla] = useState();
  const [possuiArea, setPossuiArea] = useState(false);
  const [possuiDepartamento, setPossuiDepartamento] = useState(false);
  const [caracteristicaServicoMaoDeObraAlocadaPTR, setCaracteristicaServicoMaoDeObraAlocadaPTR] = useState(false);
  const [possuiSubContratacao, setPossuiSubContratacao] = useState(false);
  const [areas, setAreas] = useState<OptionProps[]>();
  const [departamentos, setDepartamentos] = useState<OptionProps[]>();
  const [carregarDepartamento, setCarregarDepartamento] = useState<boolean>(false);
  const [municipiosOptions, setMunicipiosOptions] = useState([]);
  const [municipiosOptionsComum, setMunicipiosOptionsComum] = useState([]);
  const [infoComplementarData] = usePromise(
    () => {
      return selectedItem ? getInformacaoComplementarById(selectedItem.id) : Promise.resolve(undefined);
    },
    [selectedItem],
    {} as AbaInformacaoComplementar,
  );

  const submitDadosReajuste = (values: any) => {
    updateDadosReajusteContrato(values);
  };
  const submitResponsaveisMrn = (values: any) => updateResponsaveisMrnContrato(values);
  const submitResponsaveisFornecedor = (values: any) => updateResponsaveisFornecedorContrato(values);
  const submitFrequenciaMedicao = (values: any) => updateFrequenciaMedicaoContrato(values);

  const submitOutrasInformacoes = (values: any) => {
    if (possuiSubContratacao == false
      && infoComplementarData.caracteristicaServico_MaoDeObraAlocadaPTR) {
      Modal.confirm({
        title: 'SUBCONTRATAÇÕES',
        content:
          'Ao desabilitar o campo "Mão de Obra alocada em PTR" a aba “Subcontratações" será removida. Deseja prosseguir?',
        cancelText: 'Cancelar',
        onCancel: () => { },
        okText: 'SIM',
        onOk: () => {
          updateOutrasInformacoesContrato(values).then((resp: any) => {
            if (resp.valid) {
              onUpdate();
            }
          });
        },
      });
    } else {
      updateOutrasInformacoesContrato(values).then((resp: any) => {
        if (resp.valid) {
          onUpdate();
        }
      });
    }
  };

  const submitCronologiaMedicao = (values: any) => {
    updateCronologiaMedicaoContrato(values).then(resp => {
      if (resp.valid) {
        onUpdate();
      }
    });
  };

  const [classificacoesServicosNivel1Options, setClassificacoesServicosNivel1Options] = useState([]);
  const [classificacoesServicosNivel2Options, setClassificacoesServicosNivel2Options] = useState([]);
  const [classificacoesServicosNivel3Options, setClassificacoesServicosNivel3Options] = useState([]);

  const [fiscalOptions] = usePromise(getAllFiscaisOptions, [], [] as OptionProps[]);
  const [tecnicoOptions] = usePromise(getAllTenicoMedicaoOptions, [], [] as OptionProps[]);
  const [hasResponsavelTac, setHasResponsavelTac] = useState(true);

  useEffect(() => {
    setValorFrequenciaSla(infoComplementarData.informacaoComplementar_FrequenciaSla);
    setIdDiretoria(infoComplementarData.informacaoComplementar_DiretoriaId);
    setTipoMedicao(infoComplementarData.informacaoComplementar_TipoMedicaoCodigo);
    setFrequencia(infoComplementarData.informacaoComplementar_FrequenciaMedicaoQuantitativaId);
    setPossuiSLA(infoComplementarData.informacaoComplementar_PossuiSla);
    setIdAreaId(infoComplementarData.informacaoComplementar_AreaId);
    setPossuiArea(infoComplementarData.informacaoComplementar_PossuiArea);
    setPossuiDepartamento(infoComplementarData.informacaoComplementar_PossuiDepartamento);
    setHasResponsavelTac(infoComplementarData.hasResponsavelTac);

    if (infoComplementarData.classificacaoServicoNivel1Id) {
      getClassificacoesNivel2(infoComplementarData.classificacaoServicoNivel1Id);
    }
    if (infoComplementarData.classificacaoServicoNivel2Id) {
      getClassificacoesNivel3(infoComplementarData.classificacaoServicoNivel2Id);
    }

    if (infoComplementarData.caracteristicaServico_MaoDeObraAlocadaPTR) {
      setCaracteristicaServicoMaoDeObraAlocadaPTR(infoComplementarData.caracteristicaServico_MaoDeObraAlocadaPTR);
    }
  }, [infoComplementarData]);

  useEffect(() => {
    if (selectedItem) {
      getAllMunicipiosOptions().then((data: any) => setMunicipiosOptions(data.filter(e => e.fav === false)));
      getAllMunicipiosOptions().then((data: any) => setMunicipiosOptionsComum(data.filter(e => e.fav === true)));

      setPossuiSubContratacao(selectedItem.possuiSubContratacao);
      // console.log("selectedItem", selectedItem)

    }
  }, [selectedItem]);

  const submitDadosClassificacaoServico = (values: any) => {
    updateDadosClassificacaoServicoContrato(values).then(data => {
      onUpdate();
    });
  };

  const handleChangeDiretoria = (value: string) => {
    setIdDiretoria(value);
    limparCampoArea();
    limparCampoDepartamento();
  };

  useEffect(() => {
    if (idDiretoria) {
      getAllAreasByDiretoriaOptions(idDiretoria).then(data => {
        let areas = [...data];
        setAreas(areas);
      });
      getAllDepartamentoProDiretoriaIdOptions(idDiretoria).then(data => {
        let departamentos = [...data];
        setDepartamentos(departamentos);
      });
    }
  }, [idDiretoria]);

  useEffect(() => {
    if (idAreaId) {
      getAllDepartamentoProAreaIdOptions(idAreaId).then(data => {
        let departamentos = [...data];
        setDepartamentos(departamentos);
      });
    } else if (idDiretoria) {
      getAllDepartamentoProDiretoriaIdOptions(idDiretoria).then(data => {
        let departamentos = [...data];
        setDepartamentos(departamentos);
      });
    }
  }, [idAreaId]);

  useEffect(() => {
    getClassificacaoServicoForOptions().then(data => setClassificacoesServicosNivel1Options(data));
  }, []);

  const getClassificacoesNivel2 = (idPai: string) => {
    getClassificacaoServicoForOptions(idPai).then(data => setClassificacoesServicosNivel2Options(data));
  };

  const getClassificacoesNivel3 = (idPai: string) => {
    getClassificacaoServicoForOptions(idPai).then(data => setClassificacoesServicosNivel3Options(data));
  };

  const onClicArea = (id: string) => {
    limparCampoDepartamento();
    setIdAreaId(id);
  };

  const limparCampoDepartamento = () => {
    const departamento = document.getElementById('informacaoComplementar_DepartamentoId');
    if (departamento) {
      const botaoLimparDoDepartamento = departamento.getElementsByClassName('ant-select-selection__clear');
      if (botaoLimparDoDepartamento.length > 0) botaoLimparDoDepartamento[0].click();
    }
  };

  const limparCampoArea = () => {
    const area = document.getElementById('informacaoComplementar_AreaId');
    if (area) {
      const botaoLimparDaArea = area.getElementsByClassName('ant-select-selection__clear');
      if (botaoLimparDaArea.length > 0) botaoLimparDaArea[0].click();
    }
  };

  const [file, setFile] = useState();
  const { formProps } = useContext(FormContext);

  return (
    <>
      <Visibility visible={isMultiplosGestores == true}>
        <PanelResponsaveisMrnV2
          contratoId={selectedItem && selectedItem.id}
          isConsolidado={isConsolidado && isConsolidado}
        />
      </Visibility>

      <Visibility visible={isMultiplosGestores == true}>
        <PanelResponsaveisFornecedorV2
          contratoId={selectedItem && selectedItem.id}
          isConsolidado={isConsolidado && isConsolidado}
        />
      </Visibility>

      <Visibility visible={!isMultiplosGestores}>
        <Collapse bordered={false} expandIcon={() => <Icon type="arrows-right_4" />}>
          <Panel key="responsaveisMRN" header={<span>Responsáveis MRN</span>} style={{ border: 0 }}>
            <MasterDetailForm
              onSubmit={submitResponsaveisMrn}
              initialValues={infoComplementarData}
              validationSchema={Yup.object().shape({
                informacaoComplementar_DiretoriaId: Yup.string().required('Diretoria deve ser informada'),
                informacaoComplementar_GestorId: Yup.string().required('Gestor deve ser informado'),
                informacaoComplementar_FiscalId: Yup.string().required('Fiscal deve ser informado'),
              })}>
              <Widget
                actions={[
                  hasPermission(['CONTRATO_INF_COMPLEMENTAR_EDITAR']) && (
                    <FormSubmitButton noIcon type="primary">
                      <FormatText id="ui.commons.save" uppercase />
                    </FormSubmitButton>
                  ),
                ]}>
                <FormSelect
                  showSearch
                  optionFilterProp="children"
                  filterOption={(input: any, item: any) => {
                    return item.props.children.props.id.toString().toLowerCase().startsWith(input.toLowerCase());
                  }}
                  label="Gestor"
                  name="informacaoComplementar_GestorId"
                  placeholder="Selecione uma opção"
                  required
                  getOptions={getAllGestoresOptions}
                  span={3}
                />
                <FormSelect
                  showSearch
                  optionFilterProp="children"
                  filterOption={(input, item) => {
                    return item.props.children.props.id.toString().toLowerCase().startsWith(input.toLowerCase());
                  }}
                  label="Fiscal"
                  name="informacaoComplementar_FiscalId"
                  required
                  options={fiscalOptions}
                  span={3}
                />
                <FormSelect
                  showSearch
                  optionFilterProp="children"
                  filterOption={(input, item) => {
                    return item.props.children.props.id.toString().toLowerCase().startsWith(input.toLowerCase());
                  }}
                  label="Fiscal Alternativo"
                  name="informacaoComplementar_FiscalAlternativoId"
                  placeholder=""
                  options={fiscalOptions}
                  span={3}
                  allowClear
                />
                <FormSelect
                  showSearch
                  optionFilterProp="children"
                  filterOption={(input, item) => {
                    return item.props.children.props.id.toString().toLowerCase().startsWith(input.toLowerCase());
                  }}
                  label="Técnico Medição"
                  name="informacaoComplementar_TecnicoMedicaoId"
                  placeholder=""
                  options={tecnicoOptions}
                  span={3}
                  allowClear
                />

                <FormSelect
                  showSearch
                  optionFilterProp="children"
                  filterOption={(input, item) => {
                    return item.props.children.props.id.toString().toLowerCase().startsWith(input.toLowerCase());
                  }}
                  label="Adm. Contrato"
                  placeholder="Selecione uma opção"
                  name="informacaoComplementar_AdministradorContratoId"
                  span={3}
                  allowClear
                  getOptions={getAllAdministradoresContratoOptions}
                />

                <FormSelect
                  showSearch
                  optionFilterProp="children"
                  filterOption={(input, item) => {
                    return item.props.children.props.id.toString().toLowerCase().startsWith(input.toLowerCase());
                  }}
                  label="Adm. Contrato Alternativo"
                  name="informacaoComplementar_AdministradorContratoAlternativoId"
                  span={3}
                  placeholder="Selecione uma opção"
                  allowClear
                  getOptions={getAllAdministradoresContratoOptions}
                />

                <FormDatePicker
                  format="DD/MM/YYYY"
                  label="Data Validade Início"
                  name="informacaoComplementar_DataValidaInicio"
                  span={3}
                />
                <FormDatePicker
                  format="DD/MM/YYYY"
                  label="Data Validade Fim"
                  name="informacaoComplementar_DataValidaFinal"
                  span={3}
                />

                <FormSelect
                  showSearch
                  optionFilterProp="children"
                  filterOption={(input, item) => {
                    return item.props.children.props.id.toString().toLowerCase().startsWith(input.toLowerCase());
                  }}
                  label="Responsável Pelo Rateio"
                  name="informacaoComplementar_ResponsavelRateioId"
                  span={3}
                  placeholder="Selecione uma opção"
                  allowClear
                  getOptions={getAllUsuarioResponsavelRateioOptions}
                />
                {hasPermission(['CONTRATO_GERAL_ATIVAR_INATIVAR']) ? (
                  <FormSwitch
                    label="Requer aprovações NDA?"
                    name="informacaoComplementar_ContratoLegivelParaProcessoNda"
                    span={4}
                  />
                ) : (
                  <> </>
                )}

                <Divider />

                <FormSelect
                  label="Diretoria"
                  name="informacaoComplementar_DiretoriaId"
                  placeholder="Selecione uma opção"
                  required
                  getOptions={getAllDiretoriasOptions}
                  onChange={value => handleChangeDiretoria(value)}
                  span={6}
                />

                <FormSwitch
                  onClick={value => {
                    if (possuiArea) {
                      limparCampoArea();
                      setCarregarDepartamento(!carregarDepartamento);
                    }
                    setPossuiArea(!possuiArea);
                  }}
                  label="Possui Área?"
                  name="informacaoComplementar_PossuiArea"
                  span={3}
                />

                <FormSwitch
                  onClick={value => {
                    if (possuiDepartamento) {
                      limparCampoDepartamento();
                    }
                    setPossuiDepartamento(!possuiDepartamento);
                  }}
                  label="Possui Departamento?"
                  name="informacaoComplementar_PossuiDepartamento"
                  span={3}
                />

                <FormSelect
                  label="Área"
                  name="informacaoComplementar_AreaId"
                  id="informacaoComplementar_AreaId"
                  options={areas}
                  span={6}
                  placeholder=""
                  onChange={value => onClicArea(value as string)}
                  allowClear
                  disabled={!possuiArea}
                  required={possuiArea === true ? possuiArea : false}
                />

                <FormSelect
                  showSearch
                  optionFilterProp="children"
                  filterOption={(input, item) => {
                    return item.props.children.props.id.toString().toLowerCase().startsWith(input.toLowerCase());
                  }}
                  label="Departamento"
                  name="informacaoComplementar_DepartamentoId"
                  id="informacaoComplementar_DepartamentoId"
                  options={departamentos}
                  span={6}
                  placeholder=""
                  allowClear
                  required={possuiDepartamento === true ? possuiDepartamento : false}
                  disabled={!possuiDepartamento}
                />
              </Widget>
            </MasterDetailForm>
          </Panel>
        </Collapse>
      </Visibility>

      <Visibility visible={!isMultiplosGestores}>
        <Collapse bordered={false} expandIcon={() => <Icon type="arrows-right_4" />}>
        <Panel key="responsaveisFornecedor" header={<span>Responsáveis Fornecedor</span>} style={{ border: 0 }}>
          <MasterDetailForm
            onSubmit={submitResponsaveisFornecedor}
            initialValues={infoComplementarData}
            validationSchema={Yup.object().shape({
              informacaoComplementar_Responsavel: Yup.string()
                .required('Responsável deve ser informada')
                .max(200, 'O nome do responsável deve ter no máximo 200 caracteres.'),
              informacaoComplementar_EmailResponsavel: Yup.string()
                .required('E-mail do Responsável deve ser informado')
                .email('Deve ser informado um endereço de e-mail válido')
                .max(200, 'O E-mail do Responsável deve ter no máximo 200 caracteres.'),
              informacaoComplementar_EmailResponsavelFinanceiro: Yup.string()
                .required('E-mail do Responsável Financeiro deve ser informado')
                .email('Deve ser informado um endereço de e-mail válido')
                .max(200, 'O E-mail do Responsável Financeiro deve ter no máximo 200 caracteres.'),
            })}>
            <Widget
              actions={[
                hasPermission(['CONTRATO_INF_COMPLEMENTAR_EDITAR']) && (
                  <FormSubmitButton noIcon type="primary">
                    <FormatText id="ui.commons.save" uppercase />
                  </FormSubmitButton>
                ),
              ]}>
              <FormInput label="Responsável" name="informacaoComplementar_Responsavel" span={4} />
              <FormInput label="E-mail do Responsável" name="informacaoComplementar_EmailResponsavel" span={4} />
              <FormInput
                label="E-mail do Responsável Financeiro"
                name="informacaoComplementar_EmailResponsavelFinanceiro"
                span={4}
              />
              <FormInput label="Gestor" name="informacaoComplementar_FornecedorGestorNome" span={4} disabled />
              <FormInput
                label="E-mail do Gestor"
                name="informacaoComplementar_FornecedorGestorEmail"
                span={4}
                disabled
              />
              <FormDatePicker
                format="DD/MM/YYYY"
                label="Último acesso do Gestor"
                name="informacaoComplementar_FornecedorGestorUltimoAcesso"
                span={4}
                disabled
              />
              <FormInput label="Fiscal" name="informacaoComplementar_NomeFiscal" span={4} disabled />
              <FormInput
                label="E-mail do Fiscal"
                name="informacaoComplementar_FornecedorEmailFiscal"
                span={4}
                disabled
              />
              <FormDatePicker
                format="DD/MM/YYYY"
                label="Último acesso do Fiscal"
                name="informacaoComplementar_UltimoAcessoFiscal"
                span={4}
                disabled
              />
              <FormInput label="Financeiro" name="informacaoComplementar_NomeFinanceiro" span={4} disabled />
              <FormInput
                label="E-mail do Financeiro"
                name="informacaoComplementar_FornecedorEmailFinanceiro"
                span={4}
                disabled
              />
              <FormDatePicker
                format="DD/MM/YYYY"
                label="Último acesso do Financeiro"
                name="informacaoComplementar_UltimoAcessoFinanceiro"
                span={4}
                disabled
              />
              {
                hasResponsavelTac && (
                  <>
                    <FormInput label="Responsável TAC" name="informacaoComplementar_ResponsavelTac" span={4} disabled />
                    <FormInput
                      label="E-mail do Responsável TAC"
                      name="informacaoComplementar_EmailResponsavelTac"
                      span={4}
                      disabled
                    />
                    <FormDatePicker
                      format="DD/MM/YYYY"
                      label="Último acesso do Responsável TAC"
                      name="informacaoComplementar_UltimoAcessoResponsavelTac"
                      span={4}
                      disabled
                    />
                  </>
                )
              }
            </Widget>
          </MasterDetailForm>
        </Panel>
        </Collapse>
      </Visibility>
      <Collapse bordered={false} expandIcon={() => <Icon type="arrows-right_4" />}>
        <Panel key="dadosReajuste" header={<span>Dados de Reajuste</span>} style={{ border: 0 }}>
          <MasterDetailForm
            validationSchema={Yup.object().shape({
              informacaoComplementar_FrequenciaReajuste: Yup.number().min(0, 'Informe um número de mês valido.'),
              informacaoComplementar_IndiceReajuste: Yup.string().max(
                2000,
                'O Índice de Reajuste deve ter no máximo 2000 caracteres.',
              ),
            })}
            onSubmit={submitDadosReajuste}
            initialValues={infoComplementarData}>
            <FormContext.Consumer>
              {({ formProps }) =>
                <Widget
                  actions={[
                    hasPermission(['CONTRATO_INF_COMPLEMENTAR_EDITAR']) && (
                      <FormSubmitButton noIcon type="primary">
                        <FormatText id="ui.commons.save" uppercase />
                      </FormSubmitButton>
                    ),
                  ]}>
                  <FormDatePicker label="Data Base" name="informacaoComplementar_DataBase" format="DD/MM/YYYY" allowClear onChange={e => {
                    formProps && formProps.setFieldValue("informacaoComplementar_DataBase", e);
                  }} span={4} />
                  <FormInput
                    type="number"
                    min="0"
                    label="Frequência de Reajuste (em meses)"
                    name="informacaoComplementar_FrequenciaReajuste"
                    span={4}
                  />
                  <FormTextArea label="Índice de Reajuste" name="informacaoComplementar_IndiceReajuste" rows={6} />
                </Widget>

              }
            </FormContext.Consumer>
          </MasterDetailForm>
        </Panel>
      </Collapse>
      <Collapse bordered={false} expandIcon={() => <Icon type="arrows-right_4" />}>
        <Panel key="frequenciaMedicao" header={<span>Frequência de Medição</span>} style={{ border: 0 }}>
          <MasterDetailForm
            onSubmit={submitFrequenciaMedicao}
            validationSchema={Yup.object().shape({
              informacaoComplementar_TipoMedicaoCodigo: Yup.string().required('O Tipo de Medição deve ser informado'),
              informacaoComplementar_FrequenciaMedicaoQuantitativaId:
                TipoMedicao == 2 ? Yup.string().required('A frequência de Medição deve ser informada') : Yup.string(),
              informacaoComplementar_DataPrimeiraMedicao:
                TipoMedicao == 2 ? Yup.string().required('A data da 1° Medição deve ser informada') : Yup.string(),
              informacaoComplementar_FrequenciaSla:
                PossuiSLA && TipoMedicao == 2
                  ? Yup.string().required('A frequência de SLA deve ser informada')
                  : Yup.string(),
            })}
            initialValues={infoComplementarData}>
            <Widget
              actions={[
                hasPermission(['CONTRATO_INF_COMPLEMENTAR_EDITAR']) && (
                  <FormSubmitButton noIcon type="primary">
                    <FormatText id="ui.commons.save" uppercase />
                  </FormSubmitButton>
                ),
              ]}>
              <FormSelect
                label="Tipo de Medição"
                name="informacaoComplementar_TipoMedicaoCodigo"
                placeholder="Selecione uma opção"
                required
                getOptions={getAllTiposMedicaoOptions}
                onChange={value => {
                  setTipoMedicao(value);
                  setValorFrequenciaSla(undefined);
                  setFrequencia(undefined);
                  if (value == undefined || value == 1) setFrequencia(undefined);
                }}
                span={4}
              />
              <FormSelect
                label="Frequência"
                name="informacaoComplementar_FrequenciaMedicaoQuantitativaId"
                placeholder="Selecione uma opção"
                required={TipoMedicao == 2}
                getOptions={getAllFrequenciasOptions}
                value={frequencia}
                onChange={value => setFrequencia(value)}
                disabled={TipoMedicao == undefined || TipoMedicao == 1}
                span={4}
              />
              <FormSwitch
                onClick={value => {
                  setValorFrequenciaSla(undefined);
                  setPossuiSLA(value);

                }}
                label="Possui SLA monitorado?"
                name="informacaoComplementar_PossuiSla"
                span={4}
              />

              <FormSelect
                label="Frequência de SLA"
                name="informacaoComplementar_FrequenciaSla"
                placeholder="Selecione uma opção"
                required={PossuiSLA && TipoMedicao == 2}
                getOptions={getAllFrequenciasSlaOptions}
                disabled={!PossuiSLA || TipoMedicao != 2}
                span={4}
                onChange={value => {
                  setValorFrequenciaSla(value);
                }}
                value={valoFrequenciaSla}
              />

              {TipoMedicao != undefined && TipoMedicao != 1 ? (
                <FormDatePicker
                  format="DD/MM/YYYY"
                  label="Data da 1° Medição"
                  name="informacaoComplementar_DataPrimeiraMedicao"
                  span={4}
                />
              ) : (
                <></>
              )}

              {TipoMedicao != undefined && frequencia != undefined && TipoMedicao != 1 && frequencia == EGuidTipoSasFrequenciaMedicao.Mensal.toLocaleLowerCase() ? (
                <FormInput
                  label="Dia Medição"
                  name="informacaoComplementar_DiaMedicao"
                  span={4}
                  validateSchema={Yup.number()
                    .max(28, 'O dia de medição não pode ser maior que 28')
                    .nullable()
                  }
                />
              ) : (
                <></>
              )}
            </Widget>
          </MasterDetailForm>
        </Panel>
      </Collapse>

      <Collapse bordered={false} expandIcon={() => <Icon type="arrows-right_4" />}>
        <Panel key="cronologiaMedicao" header={<span>Cronologia de Medição do Contrato</span>} style={{ border: 0 }}>
          <MasterDetailForm
            onSubmit={submitCronologiaMedicao}
            validationSchema={Yup.object().shape({
              informacaoComplementar_DataMensalLimiteInserirMedicao: Yup.number()
                .min(1, 'O valor deve ser igual ou maior que 1.')
                .max(31, 'O valor deve ser igual ou menor que 31.')
                .nullable()
                .when('informacaoComplementar_DataMensalLimiteInserirMedicaoAplicavel', {
                  is: true,
                  then: Yup.number().required('O campo é obrigatório quando aplicável.'),
                }),
              informacaoComplementar_DataMensalLimiteValidarMedicao: Yup.number()
                .min(1, 'O valor deve ser igual ou maior que 1.')
                .max(31, 'O valor deve ser igual ou menor que 31.')
                .nullable()
                .when('informacaoComplementar_DataMensalLimiteValidarMedicaoAplicavel', {
                  is: true,
                  then: Yup.number().required('O campo é obrigatório quando aplicável.'),
                }),
            })}
            initialValues={infoComplementarData}>
            <Widget
              actions={[
                hasPermission(['CONTRATO_INF_COMPLEMENTAR_EDITAR']) && ( // criar permisao para esta parte
                  <FormSubmitButton noIcon type="primary">
                    <FormatText id="ui.commons.save" uppercase />
                  </FormSubmitButton>
                ),
              ]}>
              <FormTextArea
                label="Condição de Pagamento"
                name="informacaoComplementar_CondicaoPagamento"
                rows={1}
                span={4}
                disabled={!hasPermission(['CONTRATO_GERAL_EDITAR_DADOS_INTEGRACAO'])}
              />
              <FormNumber
                label="Apresentação do BM pelo Fornecedor"
                name="informacaoComplementar_DataMensalLimiteInserirMedicao"
                span={3}
                size="small"
                min={0}
                max={31}
              />
              <FormSwitch
                label="Aplicável?"
                name="informacaoComplementar_DataMensalLimiteInserirMedicaoAplicavel"
                span={1}
              />
              <FormNumber
                label="Aprovação do BM pela MRN"
                name="informacaoComplementar_DataMensalLimiteValidarMedicao"
                span={3}
                size="small"
                min={0}
                max={31}
              />
              <FormSwitch
                label="Aplicável?"
                name="informacaoComplementar_DataMensalLimiteValidarMedicaoAplicavel"
                span={1}
              />

              <FormNumber
                label="Reapresentação do BM pelo Fornecedor"
                name="informacaoComplementar_DataMensalLimiteReapresentarMedicao"
                span={4}
                size="small"
                min={0}
                max={31}
              />

              <FormNumber
                label="Reavaliação do BM pela MRN"
                name="informacaoComplementar_DataMensalLimiteReavaliarMedicao"
                span={4}
                size="small"
                min={0}
                max={31}
              />

              <FormNumber
                label="Autorização de Faturamento"
                name="informacaoComplementar_DataMensalLimiteAutorizarFaturamento"
                span={4}
                size="small"
                min={0}
                max={31}
              />
            </Widget>
          </MasterDetailForm>
        </Panel>
      </Collapse>

      <Collapse bordered={false} expandIcon={() => <Icon type="arrows-right_4" />}>
        <Panel key="classificacaoServicos" header={<span>Classificação de Serviços</span>} style={{ border: 0 }}>
          <MasterDetailForm onSubmit={submitDadosClassificacaoServico} initialValues={infoComplementarData}>
            <FormContext.Consumer>
              {({ formProps }) => (
                <Widget
                  actions={[
                    hasPermission(['CONTRATO_GERAL_EDITAR']) && (
                      <FormSubmitButton noIcon={true} type="primary">
                        <FormatText id="ui.commons.save" uppercase />
                      </FormSubmitButton>
                    ),
                  ]}>
                  <FormSelect
                    options={classificacoesServicosNivel1Options}
                    label="Nível 1"
                    span={4}
                    name="classificacaoServicoNivel1Id"
                    onChange={e => {
                      if (formProps) {
                        formProps.setFieldValue('classificacaoServicoNivel2Id', undefined);
                        formProps.setFieldValue('classificacaoServicoNivel3Id', undefined);
                      }
                      getClassificacoesNivel2(e.toString());
                    }}
                    required
                  />
                  <FormSelect
                    options={classificacoesServicosNivel2Options}
                    label="Nível 2"
                    span={4}
                    name="classificacaoServicoNivel2Id"
                    onChange={e => {
                      if (formProps) {
                        formProps.setFieldValue('classificacaoServicoNivel3Id', undefined);
                      }
                      getClassificacoesNivel3(e.toString());
                    }}
                    required
                  />
                  <FormSelect
                    options={classificacoesServicosNivel3Options}
                    label="Nível 3"
                    span={4}
                    name="classificacaoServicoNivel3Id"
                    required
                  />
                </Widget>
              )}
            </FormContext.Consumer>
          </MasterDetailForm>
        </Panel>
      </Collapse>

      <Collapse bordered={false} expandIcon={() => <Icon type="arrows-right_4" />}>
        <Panel key="outrasInformacoes" header={<span>Outras Informações</span>} style={{ border: 0 }}>
          <MasterDetailForm onSubmit={submitOutrasInformacoes} initialValues={infoComplementarData}>
            <Widget
              actions={[
                hasPermission(['CONTRATO_INF_COMPLEMENTAR_EDITAR']) && (
                  <FormSubmitButton noIcon type="primary">
                    <FormatText id="ui.commons.save" uppercase />
                  </FormSubmitButton>
                ),
              ]}>
              <FormSwitch
                label="Possui Documentação Acessória?"
                name="informacaoComplementar_PossuiDocumentacaoAcessorial"
                span={3}
              />
              <FormSwitch
                label="Possui Seguros e Garantias?"
                name="informacaoComplementar_PossuiSeguroEGarantia"
                span={3}
              />
              <FormSwitch
                label="Possui Processo de Rateio?"
                name="informacaoComplementar_UtilizaProcessoRateio"
                span={3}
              />
              <FormSwitch
                label="Documentos de Cobrança automáticos?"
                name="informacaoComplementar_AprovacaoPagamentoAutomatica"
                span={3}
              />

              <FormSwitch label="Crédito de PIS/COFINS?" name="caracteristicaServico_CreditoPisCofins" span={3} />
              <FormSwitch
                label="Mão de Obra alocada em PTR?"
                name="caracteristicaServico_MaoDeObraAlocadaPTR"
                span={3}
                checked={caracteristicaServicoMaoDeObraAlocadaPTR}
                onClick={() => setCaracteristicaServicoMaoDeObraAlocadaPTR(!caracteristicaServicoMaoDeObraAlocadaPTR)}
              />
              <FormSwitch
                label="Mão de Obra alocada fora de PTR?"
                name="caracteristicaServico_MaoDeObraAlocadaForaPTR"
                span={3}
              />
              <FormSwitch
                label="MultiplosGestores"
                name="isMultiplosGestores"
                checked={isMultiplosGestores}
                disabled
                span={3}
              /> 
              <FormSwitch
                label="Faturamento Direto"
                name="isFaturamentoDireto"
                span={3}
              />
              <FormSwitch
                label="Possui anexo de tratamento de dados pessoais?"
                name="possuiAnexoTratamentoDadosPessoais"
                span={3}
              />
              <Col span={12}>
                {municipiosOptionsComum.length > 0 ? (
                  <FormCheckbox
                    label="Local de Prestação de Serviço"
                    name="caracteristicaServico_LocaisServicoCheckbox"
                    options={municipiosOptionsComum}
                  />
                ) : (
                  <></>
                )}
                <FormSelect
                  name="caracteristicaServico_LocaisServicoList"
                  mode="multiple"
                  options={municipiosOptions}
                  span={6}
                  filterOption={(input, item) => {
                    return item.props.children.props.id.toString().toLowerCase().includes(input.toLowerCase());
                  }}
                />
              </Col>
            </Widget>
          </MasterDetailForm>
        </Panel>
      </Collapse>
    </>
  );
};

export default AbaInfoComplementar;
